module.exports = __webpack_public_path__ + "static/aerial-views-xiii-a22dba7cf30accbd52606fd2853c6e16.jpg";